import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Highlight from "react-highlight";
import _ from "lodash";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";

import { connect } from "react-redux";
import { LUCIA_TENANT_NAME } from "../../../../constants";

class EmbedConnectorDialog extends React.Component {
  getBotName(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return "'Lucia Assistant'";
    }

    return "'FAQ Bot Name'";
  }

  getWelcomeMessage(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return "'Hello, welcome to the Lucia Assistant.'";
    }

    return "'Hello User! Welcome to the Responsum FAQ chat.'";
  }

  getExamplePhrases(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return '["What guidelines does Lucia use?", "What is Atrial Fibrillation?", "Why does Atrial Fibrillation increase my risk of stroke?"]';
    }

    return '["enter", "multiple examples", "here"]';
  }

  getChatImage(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return `'https://${window.location.hostname}/images/chatbots/Lucia_symbol_positive.png'`;
    }

    return "'https://chatplugin.responsum.ai/img/responsum.png'";
  }

  getChatImageLink(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return "'https://luciaguidelines.com/'";
    }

    return "'https://responsum.ai'";
  }

  getBubblesFlag(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return "true";
    }

    return "false";
  }

  getContinuousListeningFlag(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return "true";
    }

    return "false";
  }

  getColor(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return `{
            primary: '#445566',
            secondary: '#FFFFFF'
        }`;
    }

    return `{
          primary: '#002c52'
        }`;
  }

  render() {
    const { tenant } = this.props;
 
    return (
      <Dialog open={this.props.open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="draggable-dialog-title"><Typography variant="h5">Embed Assistant to your site</Typography></DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            Add the following script tag inside the &lt;head&gt; of your site: 
          </DialogContentText>
          <Highlight language="html">
            {`<script async type="text/javascript" id="responsum" src="https://chatplugin.responsum.ai/core/responsum.min.js?id=${_.get(this.props.publicChatbotProps, "data.GUID", "")}"></script>`}
          </Highlight>
         <DialogContentText style={{fontSize:12}}>
            To test before embedding click <a target="_blank" href={`http://responsum.ai/responsum.ai.assistant/${_.get(this.props.publicChatbotProps, "data.GUID", "")}.html`}>here</a>.
            Plugin expires at :{" "}
          {new Date(parseInt(_.get(this.props.publicChatbotProps, "data.expiration_date", "")) * 1000).toUTCString()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleCancelEmbed} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    tenant: state.skill.tenant
  };
};

export default connect(mapStateToProps)(EmbedConnectorDialog);
